/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        card: {
            container: {
                gap: {
                    value: "24px",
                    type: "dimension",
                },
                paddingLeft: {
                    value: "24px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "24px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "24px",
                    type: "dimension",
                },
                borderRadius: {
                    value: "12px",
                    type: "dimension",
                },
                borderWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderStyle: {
                    value: "solid",
                    type: "strokeStyle",
                },
                borderColor: {
                    value: "#dadada",
                    type: "color",
                },
            },
            header: {
                status: {
                    gap: {
                        value: "12px",
                        type: "dimension",
                    },
                    marginBottom: {
                        value: "24px",
                        type: "dimension",
                    },
                    label: {
                        fontSize: {
                            value: "0.875rem",
                            type: "dimension",
                        },
                        lineHeight: {
                            value: "1.25rem",
                            type: "dimension",
                        },
                        letterSpacing: {
                            value: "0.2px",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 600,
                            type: "number",
                        },
                        success: {
                            color: {
                                value: "#3f6900",
                                type: "color",
                            },
                        },
                        warning: {
                            color: {
                                value: "#6a5f00",
                                type: "color",
                            },
                        },
                        notification: {
                            color: {
                                value: "#006879",
                                type: "color",
                            },
                        },
                        error: {
                            color: {
                                value: "#921a1d",
                                type: "color",
                            },
                        },
                    },
                },
                labels: {
                    gap: {
                        value: "0px",
                        type: "dimension",
                    },
                    marginBottom: {
                        value: "4px",
                        type: "dimension",
                    },
                    label: {
                        fontSize: {
                            value: "0.875rem",
                            type: "dimension",
                        },
                        lineHeight: {
                            value: "1.25rem",
                            type: "dimension",
                        },
                        letterSpacing: {
                            value: "0.2px",
                            type: "dimension",
                        },
                        fontWeight: {
                            value: 400,
                            type: "number",
                        },
                        color: {
                            value: "#6f7377",
                            type: "color",
                        },
                    },
                    separator: {
                        width: {
                            value: "20px",
                            type: "dimension",
                        },
                        height: {
                            value: "20px",
                            type: "dimension",
                        },
                        dot: {
                            width: {
                                value: "4px",
                                type: "dimension",
                            },
                            height: {
                                value: "4px",
                                type: "dimension",
                            },
                            backgroundColor: {
                                value: "#d3222a",
                                type: "color",
                            },
                            borderRadius: {
                                value: "9999px",
                                type: "dimension",
                            },
                        },
                    },
                },
                title: {
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                    marginBottom: {
                        value: "4px",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "number",
                    },
                },
                subtitle: {
                    color: {
                        value: "#6f7377",
                        type: "color",
                    },
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                },
            },
            media: {
                borderRadius: {
                    value: "8px",
                    type: "dimension",
                },
            },
            footer: {
                paddingBottom: {
                    value: "24px",
                    type: "dimension",
                },
            },
            horizontal: {
                footer: {
                    paddingTop: {
                        value: "24px",
                        type: "dimension",
                    },
                    borderTopWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderTopStyle: {
                        value: "solid",
                        type: "strokeStyle",
                    },
                    borderTopColor: {
                        value: "#dadada",
                        type: "color",
                    },
                },
            },
        },
    },
};
export default tokens;
